module.exports = __webpack_public_path__ + "9f6c2ec8c8d5aacafafcfeaf818b2ca9.MP3";